import { useScreenSize, ScreenSize } from '@toasttab/use-screen-size'

export const useCalendarNumberOfMonths = (
  numberOfMonths: 1 | 2 | undefined = 1
) => {
  const screenSize = useScreenSize()
  return screenSize < ScreenSize.LG ? 1 : numberOfMonths
}
